import React from 'react';
import { PrimaryNavProps, SecondaryNavProps, SimpleSecondaryNavProps } from '../types';
import PrimaryNavDesktop from './PrimaryNavDesktop';
import SecondaryNavDesktop from './SecondaryNavDesktop';
import SimpleSecondaryNavDesktop from './SimpleSecondaryNavDesktop';
import { DummySecondaryNav } from './styles';

export type NavDesktopProps = PrimaryNavProps &
  SecondaryNavProps &
  SimpleSecondaryNavProps & { enableKeyboardNavigation?: boolean };

const NavDesktop: React.FC<NavDesktopProps> = ({
  primaryNav,
  useFourColumnLayout = false,
  showArrowsOnPrimaryNav = false,
  secondaryNav,
  activeItemIndex,
  setActiveItemIndex,
  resetNav,
  simpleSecondaryNav,
  dummyColumSectionAtEnd = false,
  enableKeyboardNavigation,
}) => {
  const numberOfPrimaryNavItems = primaryNav?.navItems.length ?? 0;
  return (
    <>
      {primaryNav && (
        <PrimaryNavDesktop
          enableKeyboardNavigation={enableKeyboardNavigation}
          primaryNav={primaryNav}
          activeItemIndex={
            activeItemIndex === null || activeItemIndex < numberOfPrimaryNavItems
              ? activeItemIndex
              : null
          }
          setActiveItemIndex={setActiveItemIndex}
          resetNav={resetNav}
          useFourColumnLayout={useFourColumnLayout}
          showArrows={showArrowsOnPrimaryNav}
          dummyColumSectionAtEnd={dummyColumSectionAtEnd}
        />
      )}
      {secondaryNav ? (
        <SecondaryNavDesktop
          enableKeyboardNavigation={enableKeyboardNavigation}
          secondaryNav={secondaryNav}
          activeItemIndex={
            activeItemIndex === null || activeItemIndex < numberOfPrimaryNavItems
              ? null
              : activeItemIndex - numberOfPrimaryNavItems
          }
          setActiveItemIndex={(index: number | null) =>
            setActiveItemIndex(index === null ? null : numberOfPrimaryNavItems + index)
          }
          resetNav={resetNav}
        />
      ) : !secondaryNav && simpleSecondaryNav ? (
        <SimpleSecondaryNavDesktop secondaryNav={simpleSecondaryNav} />
      ) : (
        <DummySecondaryNav />
      )}
    </>
  );
};

export default NavDesktop;
